var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar navbar-light bg-light py-3"},[_c('div',{staticClass:"container justify-content-center"},[_c('router-link',{staticClass:"navbar-brand home",attrs:{"tag":"div","to":{ name: 'home' }}},[_c('img',{attrs:{"src":require("../assets/images/logo/logo-regular-light.png"),"alt":"Inssa Logo"}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }